import { setUrlParams } from '../utils/url-params'

export const SIZES = [ 3, 6, 16, 24, 32 ] as const
export const PLANS = {
  monthly: 'subscription',
  single: 'onetime'
} as const

export type VariantSize = typeof SIZES[number]
export type VariantPlan = keyof typeof PLANS
export type VariantType = typeof PLANS[VariantPlan]

export interface VariantSelectParams {
  size?: VariantSize
  plan?: VariantPlan
  type?: VariantType
}

export const variantSelectUrlParams = () => {
  const url = new URL(location.href)
  const size = Number(url.searchParams.get('size')) as VariantSize
  const type = String(url.searchParams.get('type')) as VariantType
  const params: VariantSelectParams = {}
  if (SIZES.includes(size)) {
    params.size = size as VariantSize
  }
  if (Object.values(PLANS).includes(type)) {
    params.type = type
  }
  // const entry = Object.entries(PLANS).find(([ key, value ]) => key === type || value === type)
  // if (entry) {
  //   params.plan = entry[0] as VariantPlan
  // }
  return params
}

export const updateVariantSelectParams = (params: VariantSelectParams) => {
  const { size, plan, type } = params
  setUrlParams({
    size,
    type: plan ? PLANS[plan] : type
  })
}
